<div
  class="soft-ds-date-range-field-root"
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
>
  <div class="soft-ds-date-range-field-grid">
    <div class="soft-ds-date-range-field-segment">
      @if (fromLabel(); as label) {
        <label
          soft-ds-label
          [attr.for]="fromInputId"
          class="soft-ds-date-range-field-label"
          [disabled]="isDisabled() || readonly()"
          (click)="onEndpointLabelClick($event, fromEndpoint)"
        >
          {{ label }}
        </label>
      }
      <soft-ds-date-range-from-input
        #fromEndpoint
        [inputId]="fromInputId"
        [valueInput]="fromValue()"
        [toControl]="toEndpoint"
        [size]="size()"
        [pickerTrigger]="endpointPickerTrigger()"
        [readonly]="readonly()"
        [disabled]="isDisabled()"
        [placeholder]="placeholder()"
        [format]="format()"
        [changeTrigger]="changeTrigger()"
        (valueChange)="onEndpointValueChange('from', $event)"
        (blur)="onEndpointBlur()"
        (pickerOpen)="onEndpointPickerOpen($event)"
      />
    </div>

    <div class="soft-ds-date-range-field-segment">
      @if (toLabel(); as label) {
        <label
          soft-ds-label
          [attr.for]="toInputId"
          class="soft-ds-date-range-field-label"
          [disabled]="isDisabled() || readonly()"
          (click)="onEndpointLabelClick($event, toEndpoint)"
        >
          {{ label }}
        </label>
      }
      <soft-ds-date-range-to-input
        #toEndpoint
        [inputId]="toInputId"
        [valueInput]="toValue()"
        [fromControl]="fromEndpoint"
        [size]="size()"
        [pickerTrigger]="endpointPickerTrigger()"
        [readonly]="readonly()"
        [disabled]="isDisabled()"
        [placeholder]="placeholder()"
        [format]="format()"
        [changeTrigger]="changeTrigger()"
        (valueChange)="onEndpointValueChange('to', $event)"
        (blur)="onEndpointBlur()"
        (pickerOpen)="onEndpointPickerOpen($event)"
      />
    </div>
  </div>
</div>

<soft-ds-overlay
  [(open)]="open"
  [originElement]="origin"
  [content]="pickerPanel"
  [width]="overlayWidth()"
  [maxWidth]="overlayWidth()"
  [dividers]="false"
  [trapFocus]="false"
  [autoCaptureFocus]="false"
  [offset]="0"
/>

<ng-template #pickerPanel>
  <div
    class="soft-ds-date-range-field-popover"
    [class.has-shortcuts]="showShortcuts()"
    [class.has-week-numbers]="showWeekNumbers()"
  >
    <soft-ds-date-range-picker
      [value]="currentRange()"
      [showShortcuts]="showShortcuts()"
      [showWeekNumbers]="showWeekNumbers()"
      [showRangeLabels]="showRangeLabels()"
      [startField]="activeField()"
      [endpoint]="true"
      (valueChange)="onPickerValueChange($event)"
    />
  </div>
</ng-template>
